const routers = [
  {
    // 产品
    path: "/productundertake/list",
    name: "productundertake",
    component: () => import("@/views/modules/productundertake/List.vue")
  }
];
export default routers;
